import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, ImageUploadedTrackingEvent } from "./tracking";

interface TrackImageUploadedFunction {
  (): void;
}

interface UseTrackImageUploadedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackImageUploadedFunction {
  (agrs: UseTrackImageUploadedFunctionArgs): TrackImageUploadedFunction;
}

const useTrackImageUploaded: UseTrackImageUploadedFunction = ({ country, segment, customerId, tradename }) => {
  const emitUserEvent = useEmitUserEvent<ImageUploadedTrackingEvent>();

  const trackImageUploaded: TrackImageUploadedFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.IMAGE_UPLOADED,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, customerId, emitUserEvent, segment, tradename]);

  return trackImageUploaded;
};

export { useTrackImageUploaded };
